import { useTranslation } from "react-i18next";

import { colors } from "#app/theme/v2/colors";
import { spacing } from "#app/theme/v2/spacing";
import { Button } from "#components/atoms/Button/Button";
import { Text } from "#components/atoms/Typographies/Text";
import { Flex } from "#shared/view/components/Flex";

type ProcessStepConfigurationEmptyStateProps = {
  onAddProcessStep: () => void;
};

export const ProcessStepConfigurationEmptyState = ({
  onAddProcessStep,
}: ProcessStepConfigurationEmptyStateProps) => {
  const { t } = useTranslation();

  return (
    <Flex
      direction="column"
      align="center"
      gap={spacing[6]}
      style={{ padding: `${spacing[24]} ${spacing[12]}` }}
    >
      <Flex direction="column" align="center" gap={spacing[2]}>
        <Text size="base" type="medium">
          {t("onboardingV2.processStepConfiguration.emptyState.title")}
        </Text>
        <Text size="small" type="regular" color={colors.text.secondaryDefault}>
          {t("onboardingV2.processStepConfiguration.emptyState.subtitle")}
        </Text>
      </Flex>
      <Button variant="secondary" onClick={onAddProcessStep}>
        {t("onboardingV2.processStepConfiguration.emptyState.button")}
      </Button>
    </Flex>
  );
};
